import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import type { AssignmentPreview } from '../../types';

const statusVariant: Record<string, 'warning' | 'default' | 'success'> = {
  PENDING: 'warning',
  SUBMITTED: 'default',
  GRADED: 'success',
};

interface AssignmentCardProps {
  data: AssignmentPreview;
}

export function AssignmentCard({ data }: AssignmentCardProps) {
  const navigate = useNavigate();

  return (
    <Card
      className="cursor-pointer hover:shadow-md transition-shadow"
      onClick={() => navigate(data.detailUrl)}
    >
      <CardHeader className="p-4 pb-2">
        <div className="flex items-center justify-between gap-2">
          <CardTitle className="text-sm truncate">{data.title}</CardTitle>
          <Badge variant={statusVariant[data.status] ?? 'outline'} className="shrink-0">
            {data.status}
          </Badge>
        </div>
      </CardHeader>
      <CardContent className="p-4 pt-0 text-sm text-muted-foreground space-y-1">
        <p>{data.subject}</p>
        <p>Due: {new Date(data.dueDate).toLocaleDateString()}</p>
      </CardContent>
    </Card>
  );
}
